interface TransactionCurrencies {
  id: number;
  code: string;
}

export interface EntityTransactionFields {
  transaction_id: number;
  title: string;
  instrument_id: number;
  instrument_group_id: number;
  instrument_group_desc: string;
  hedging_instrument: string;
  transaction_currencies: TransactionCurrencies[];
  notional_ccy_id: number;
  notional_ccy_code: string;
  notional: number;
  bank_entity_name: string;
  trade_date: string;
}

export interface EntityTransaction extends EntityTransactionFields {
  notional_current: number;
  maturity_date: string;
  user_ccy_code: string;
  user_clean_value: number;
  user_accrued: number;
  user_market_value: number;
  user_value_date: string;
  fx_spot_trade_to_user_ccy: number;
  instrument_id: number;
  effective_date: string;
}

export interface EntityTransactionTotals {
  total_notional_current: number;
  total_user_market_value: number;
}
export interface EntityTransactionData {
  totals: EntityTransactionTotals;
  transactions: EntityTransaction[];
}

export interface HistoricalEntityTransactions extends EntityTransactionFields {
  end_date: string;
  close_out_amt: number | null;
}

export interface ActiveEntityDebt {
  debt_id: number;
  title: string;
  instrument_type_id: number;
  instrument_type_name: string;
  debt_currency_id: number;
  debt_currency_code: string;
  initial_notional: string;
  notional_current: string;
  bank_entity_name: string;
  maturity_date: string;
  effective_date: string;
  user_currency_code: string;
  user_clean_value: string;
  user_accrued: string;
  user_market_value: string;
  user_value_date: string;
  fx_spot_debt_to_user: string;
}

export interface EntityDebt {
  active: ActiveEntityDebt[];
  inactive: ActiveEntityDebt[];
  historical_date_filter?: string;
  active_totals: EntityTransactionTotals;
}

export interface EntityTransactionValue {
  [trade: string]: EntityTransctionValueData[];
}

export interface EntityTransctionValueData {
  trDirtyVal: number;
  trValDate: string;
  trId: string;
  trCalCurrency: EntityTransctionValueCurrency;
}

export interface EntityTransctionValueCurrency {
  currCode: string;
}

export interface EntityData {
  entity_id: string;
  entity_name: string;
  cds_ent_spread: number | null;
  cds_curve_name: string | null;
}

export interface EntityDocuments {
  file_name: string;
  file_path: string;
  file_type_description: string;
  s3_download_link: string;
  file_upload_date: string;
  user_name: string;
}

export interface HedgedNotionalData {
  date: string;
  hedged_amount?: number;
  fixed_debt_amount?: number;
  floating_debt_amount?: number;
  hedge_percentage?: number;
}

export interface EntityFlows {
  date: string;
  flows: number;
}

export const TotalsInitialState = {
  total_notional_current: 0,
  total_user_market_value: 0,
};

// scenario analysis graph
export interface IrTabData {
  abs_rate_move: number;
  home_currency_value: number;
  home_currency_up: number;
  home_currency_down: number;
  home_currency_diff_up: number;
  home_currency_diff_down: number;
}

export interface FxTabData {
  final_date: string;
  fx_rate_unchanged: number;
  fx_rate_up: number;
  fx_rate_down: number;
  abs_fx_move: number;
  home_currency_value: number;
  home_currency_up: number;
  home_currency_down: number;
  home_currency_diff_up: number;
  home_currency_diff_down: number;
}

export interface SummaryTabFx {
  abs_fx_move: number;
  home_currency_value: number;
  home_currency_diff_up: number;
  home_currency_diff_down: number;
}

export interface SummaryTabIr {
  abs_rate_move: number;
  home_currency_value: number;
  home_currency_diff_up: number;
  home_currency_diff_down: number;
}

export interface SummaryTab {
  FX: SummaryTabFx;
  IR: SummaryTabIr;
  home_currency_code: string;
  run_date: string;
}

export interface ScenarioAnalysisData {
  summaryTab: SummaryTab;
  IRTab: Record<string, IrTabData>;
  FXTab: Record<string, FxTabData>;
}

///trade-aggregated-values/ api
export interface EntityTradeValuesData {
  transaction_id: number;
  values: EntityTradeValuesArray[];
}
export interface EntityTradeValuesArray {
  date: string;
  dirtyVal: number;
}
